import React, { useState, useContext, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Text,
  Input,
  Icon,
  useToast,
  Link,
  Switch
} from "@chakra-ui/react";
import api from "../../services/api";
import { ProlabContext } from "../../contexts/Prolab";
import { LuDownloadCloud } from "react-icons/lu";
import { AiOutlineDelete, AiOutlineEdit, AiOutlineSave } from "react-icons/ai";
import axios from "axios";
import { environment } from "../../environment";

export default function ManualProvatis() {
  const { listDocumentsApi, createDocumentApi, updateDocumentApi, uploadDocumentApi, deleteDocumentApi } = useContext(ProlabContext);
  const toast = useToast();
  const [description, setDescription] = useState("");
  const [savedInfos, setSavedInfos] = useState([]);
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [newFile, setNewFile] = useState(null);
  const fileInputRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingDocId, setEditingDocId] = useState(null);  
  const [tempTitle, setTempTitle] = useState("");
  const [isExpertEvaluation, setIsExpertEvaluation] = useState(0);
  const [tempIsExpertEvaluation, setTempIsExpertEvaluation] = useState(false);
  const allowedExtensions = [
    "pdf", "doc", "docx"
  ];
  const handleInputIIsExpertEvaluationChange = (e) => {
    setIsExpertEvaluation(e.target.checked ? 1 : 0);
  };
  const handleInputTempIsExpertEvaluationChange = (e) => {
    setTempIsExpertEvaluation(e.target.checked ? 1 : 0);
  };
  const handleEditClick = (doc) => {
    setIsEditing(true);
    setEditingDocId(doc.id);
    setTempTitle(doc.title);
    setTempIsExpertEvaluation(doc.is_expert_evaluation);
   
  };
  const handleEditClickClose = (doc) => {
    setIsEditing(false);
  };
  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  const handleNewFileChange = (event) => {
    setNewFile(event.target.files[0]);
  };
  const handleSaveClick = async () => {
    const data = {
      id: editingDocId,
      title: tempTitle,
      is_expert_evaluation: tempIsExpertEvaluation
    };
    const formData = new FormData();
    const token = localStorage.getItem("token");
    formData.append("file", newFile);
    if(newFile != null){
      try {
        const resposeUpload = await uploadDocumentApi(editingDocId, formData);
        if(resposeUpload.status == 200){
          toast({
            title: "Upload feito com sucesso!",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          getDocumentsManual();
        }
      } catch (error) {
        console.error(error);
        toast({
          title: "Não foi possível enviar o documento. Tente novamente.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    }
    try {
      const response = await updateDocumentApi(editingDocId, data);
      if (response.status === 200) {
        toast({
          title: "Manual Atualizado com sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        getDocumentsManual()
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Erro ao atualizar a manual",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
    setIsEditing(false);
  };
  
  const handleUpload = async () => {
    const formData = new FormData();
    const token = localStorage.getItem("token");
    formData.append("category_id", "1");
    formData.append("title", title);
    formData.append("file", file);
    formData.append("is_expert_evaluation", isExpertEvaluation);
    if (title === "") {
      toast({
        title: "Preencha o campo Título",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } else if (file === null) {
      toast({
        title: "Selecione um arquivo para enviar",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } else {
      try {
        const extension = file.name.split(".").pop().toLowerCase();
        if (!allowedExtensions.includes(extension)) {
          toast({
            title: "Arquivo com formato inválido.",
            description: `O arquivo "${file.name}" não é permitido.`,
            status: "error",
            duration: 7000,
            isClosable: true,
          });
          return;
        }
        const response = await createDocumentApi(formData);
        if(response.status == 200){
          toast({
            title: "Upload feito com sucesso!",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setTitle("");
          setFile("");
          setFile([]);
          setIsExpertEvaluation(false);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          getDocumentsManual();
        }
      } catch (error) {
        console.error(error);
        toast({
          title: "Não foi possível enviar o documento. Tente novamente.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    }
  };

  async function getDocumentsManual() {
    try {
      const response = await listDocumentsApi(1);
      setSavedInfos(response.data?.[1]);
      console.log(response.data?.[1]);
    } catch (error) {
      console.log(error);
      setSavedInfos();
    }
  }

  async function deleteDocument(id) {
    const mensagem = "Tem certeza que deseja excluir o arquivo?";
    const confirmacao = window.confirm(mensagem);
    if (confirmacao){
      try {
        const response = await deleteDocumentApi(id);
        getDocumentsManual();
        toast({
          title: "Arquivo deletado com sucesso!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } catch (error) {
        console.log(error);
      }
    }
  }

  useEffect(() => {
    getDocumentsManual();
  }, []);

  return (
    <>
      <Box
        bg={"#ffff"}
        borderRadius={"15px"}
        boxShadow={"0px 7px 16px 4px #EAEAEA"}
        w={"57vw"}
        p={5}
        position={"absolute"}
        ml={"250px"}
        mt={"100px"}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <h1 fontSize="md">Atualizar manual</h1>
          <Button onClick={handleUpload}>Salvar</Button>
        </Box>

        <Box>
          <Text>Título</Text>
          <Input
            placeholder={"Digite Aqui"}
            value={title}
            onChange={handleTitleChange}
          />
        </Box>

        <Box mr="20px" mt={"20px"}>
          <Text fontSize={12}>
            Envie arquivos nas extensões de docx. doc. e PDF.
          </Text>
          <Input type="file" accept=".pdf, .doc, .docx" ref={fileInputRef} onChange={handleFileChange} />
        </Box>
        <Box mr="20px" mt={"20px"}>
          <Text>Esse manual deve ter o acesso liberado aos experts em avaliação?</Text>
          <Switch
            colorScheme="green"
            isChecked={isExpertEvaluation === 1}
            onChange={handleInputIIsExpertEvaluationChange}
          ></Switch>
        </Box>
      </Box>

      <Box mt={"425px"}></Box>
      {savedInfos?.map((info, index) => (
        <Box
          key={index}
          bg={"#ffff"}
          borderRadius={"15px "}
          boxShadow={"0px 7px 16px 4px #EAEAEA"}
          p={5}
          w={"57vw"}
          ml={"250px"}
          mt={"20px"}
        >
          <Box
            mt={"20px"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"justify-content-end"}
          ></Box>
          <Box mt={"20px"} mb={"15px"} display={"flex"} alignItems={"end"}>
            <Box mt="20px" mb="15px" display="flex" alignItems="end">
              <Box mt="20px" mb="15px">
                <Box display="flex" alignItems="end">
                  <Box>
                    {isEditing && editingDocId === info.id ? (
                      <>
                        <Text>Título</Text>
                        <Input
                          placeholder="Digite o novo título"
                          value={tempTitle}
                          onChange={(e) => setTempTitle(e.target.value)}
                        />
                      </>
                    ) : (
                      <Text fontSize="24px">{info.title}</Text>
                    )}
                  </Box>
                </Box>

                {isEditing && editingDocId === info.id && (
                  <>
                    <Box mt="20px">
                      <Text fontSize={12}>
                        Envie arquivos nas extensões de docx, doc e PDF.
                      </Text>
                      <Input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleNewFileChange}
                      />
                    </Box>

                    <Box mt="20px" mr="20px">
                      <Text>
                        Esse manual deve ter o acesso liberado aos experts em avaliação?
                      </Text>
                      <Switch
                        colorScheme="green"
                        isChecked={tempIsExpertEvaluation === 1}
                        onChange={handleInputTempIsExpertEvaluationChange}
                      />
                    </Box>
                  </>
                )}
              </Box>
            </Box>

            <Box>
              {" "}
              <Box
                background={"black"}
                borderRadius={"200px"}
                padding={1}
                marginLeft={"80px"}
              >
                <Link
                  href={
                    environment.baseURL +
                    "/storage/uploads/documents/" +
                    info.document_path
                  }
                >
                  <LuDownloadCloud
                    color="white"
                    fontSize={"24px"}
                    cursor={"pointer"}
                  />
                </Link>
              </Box>
            </Box>
            <Box
              m={5}
              gap={3}
              display={"flex"}
              justifyContent={"end"}
              alignItems={"center"}
            >
              {" "}
              <AiOutlineDelete
                cursor={"pointer"}
                fontSize={"25px"}
                color="red"
                onClick={() => deleteDocument(info.id)}
              ></AiOutlineDelete>
              {isEditing && editingDocId === info.id ? (
                <>
                  <AiOutlineSave
                    cursor={"pointer"}
                    fontSize={"20px"}
                    onClick={handleSaveClick}
                  />
                  <AiOutlineEdit
                    cursor={"pointer"}
                    fontSize={"20px"}
                    onClick={() => handleEditClickClose(info)}
                  />
                </>
              ) : (
                <>
                  <AiOutlineEdit
                    cursor={"pointer"}
                    fontSize={"20px"}
                    onClick={() => handleEditClick(info)}
                  />
                </>
              )}
            </Box>
          </Box>

          {/*
                    <Box display={'flex'} mt={'20px'} alignItems={'center'} gap={1}>
                        <Text fontSize={'16px'} color={'#888686'}>Essa dica foi útil?</Text>
                        <AiOutlineLike fontSize={'16px'} color={'#888686'} />
                        <Text fontSize={'16px'} color={'#888686'}>Sim</Text>
                        <AiOutlineDislike fontSize={'16px'} color={'#888686'} />
                        <Text fontSize={'16px'} color={'#888686'}>Não</Text>
                        
                    </Box>
                    */}
        </Box>
      ))}
    </>
  );
}
